import "./App.css";
import "./Dice.css";
import Rolldice from "./Rolldice";
function App() {
  return (
    <div className="App">
      <h1 className="slatt">Slatt Dice</h1>
      <Rolldice />
    </div>
  );
}

export default App;
